PD = PD || {};
PD.loginpage = (function (login) {
  var MOBILE_CUTOFF = 950;
  login.init = function () {

    // mobile sidebar
    function closeMobile() {
      $(".navbar__mobile").removeClass("active");
      $(document.body).removeClass("body--has-sidebar");
    }
    $(".navbar__mobile-close-btn").click(function(){
      closeMobile();
    });
    $(".navbar__mobile-toggle").click(function(){
      $(".navbar__mobile").toggleClass("active");
      $(document.body).toggleClass("body--has-sidebar");
    });


    var linkedParams = PD.utils.getUrlParam(false, 'hash');
    if (linkedParams.username) {
      // Set linked username:
      $(".login__username").val(linkedParams.username);
      $(".login__password").val("").focus();
    }

    if (linkedParams.reset) {
      var resetPasswordValues = {
        reset_password_hash: linkedParams.reset,
      };
      if (linkedParams.username) {
        resetPasswordValues["reset_password_username"] = linkedParams.username;
      }

      // Show password reset form
      _openResetPasswordForm(resetPasswordValues);
    }

    // Show login form
    if ((PD.utils.cookies.get('visitor_logged_in') || linkedParams.username || linkedParams.openLogin !== undefined) && (location.pathname === '/')) {
      $('.navbar__login-form').removeClass("hidden");

      // also open mobile nav sidebar
      $(".navbar__mobile").toggleClass("active");
      $(document.body).toggleClass("body--has-sidebar");
    }

    $('#browser-login').on('click', function () {
      $('#login-area').show();
    });

    // Forgot password click listener:
    $(document).on("click", "[data-action='forgotPassword']", login._openForgotPasswordForm);

    // Close popup on body click
    $(".navbar__login-buttons__login").click(function(e){
      $(".navbar__login-form").toggleClass("hidden");
      e.preventDefault();
    });
    $(document).on("click", _handleBodyClick);
  };

  function _handleBodyClick(e) {
    if (window.innerWidth < MOBILE_CUTOFF) { return; }
    var $target = $(e.target);
    var $closestForm = $target.closest(".navbar__login-form");
    var $closestBtns = $target.closest(".navbar__login-buttons__login");
    if ($closestForm.length === 0 && $closestBtns.length === 0) {
      $(".navbar__login-form").addClass("hidden");
    }
  }

  $(function () {
    if ($(".login-flow-container").length) {
      login.init();
    }
  });

  var _forgotPasswordWindow;
  login._openForgotPasswordForm = function () {
    if (!_forgotPasswordWindow) {
      _forgotPasswordWindow = new PD.forms.FormWindow(
        PD.homepage.__h("Forgot password"),
        [
          {
            type: "text",
            name: "username",
            label: PD.homepage.__h("Username"),
            placeholder: PD.homepage.__h("Username"),
            errorText: PD.homepage.__h("Enter a valid username"),
            mandatory: true,
            helpText: {
              title: PD.homepage.__h("Username"),
              content: PD.homepage.__h("Your username is generated based on your email.")
            },
          }
        ],
        {
          text: PD.homepage.__h('Enter your username to get an e-mail for resetting your password'),
          actionText: PD.homepage.__h("Resend"),
          cancelButton: true
        }
      );

      _forgotPasswordWindow.on("form:submitted", function (e, values) {
        $.ajax({
          type: 'POST',
          url: '/api/users/forgotpassword',
          data: JSON.stringify(values),
          contentType: "application/json",
          dataType: "json",
          success: function (data, textStatus, jqXhr) {
            // Reset e-mail sent - show feedback:
            PD.windows.notify.success(
              PD.homepage.__h("New password"),
              PD.homepage.__h("An e-mail has been sent to the registered e-mail address with a link to resetting your password.")
            );

            _forgotPasswordWindow.form.clearLoading();
            _forgotPasswordWindow.hide();
          },
          error: function (jqXhr, textStatus, errorThrown) {
            if (jqXhr.responseText) {
              let text = JSON.parse(jqXhr.responseText);
              if (text.message) {
                // Error handling:
                _forgotPasswordWindow.form.clearLoading();
                PD.windows.notify.danger(
                  PD.homepage.__h("Error"),
                  text.message
                );
                return;
              }
            } else {
              // Error handling:
              _forgotPasswordWindow.form.clearLoading();
              PD.windows.notify.danger(
                PD.homepage.__h("Error"),
                PD.utils.curlyFormat(
                  PD.homepage.__h('The system could not handle the query. Please try again or contact our support at: {phone}.'),
                  { phone: PD.homepage.Support.getPhone() }
                )
              );
            }
          }
        });
      });

      // Clear the feedback from the form:
      _forgotPasswordWindow.form.clearFeedback();
    } else {
      _forgotPasswordWindow.form.clearValues();

      _forgotPasswordWindow.form.clearFeedback();
      _forgotPasswordWindow.show();
    }
  }

  var resetPasswordWindow;
  function _openResetPasswordForm(values) {
    resetPasswordWindow = new PD.forms.FormWindow(
      PD.homepage.__h("New password"),
      [
        {
          type: "text",
          name: "reset_password_username",
          label: PD.homepage.__h("Username"),
          placeholder: PD.homepage.__h("Username"),
          errorText: PD.homepage.__h("Enter a valid username"),
          mandatory: true,
          helpText: {
            title: PD.homepage.__h("Username"),
            content: PD.homepage.__h("Your username is generated based on your email.")
          },
        }, {
          type: "password",
          name: "reset_password_password",
          label: PD.homepage.__h("Password"),
          placeholder: PD.homepage.__h("Password"),
          errorText: PD.homepage.__h("Enter a valid password."),
          mandatory: true,
          helpText: {
            title: PD.homepage.__h("Password"),
            content: PD.homepage.__h("Enter a password for your user. The password must be at minimum 6 characters long.")
          }
        }, {
          type: "password",
          name: "reset_password_password_repeat",
          label: PD.homepage.__h("Confirm password"),
          placeholder: PD.homepage.__h("Confirm password"),
          errorText: PD.homepage.__h("Enter a valid password."),
          mandatory: true,
        }, {
          type: "hidden",
          name: "reset_password_hash",
        }
      ],
      {
        text: PD.homepage.__h('Enter your username and new password'),
        cancelButton: true,
        actionText: PD.homepage.__h("Change password")
      }
    );

    if (values) {
      resetPasswordWindow.form.setValues(values);
    }

    resetPasswordWindow.on("form:submitted", function (e, values) {
      values = {
        "username": values.reset_password_username,
        "password": values.reset_password_password,
        "password_confirm": values.reset_password_password_repeat,
        "hash": values.reset_password_hash
      };
      $.ajax({
        type: 'POST',
        url: '/api/users/forgotpassword/~reset',
        data: JSON.stringify(values),
        contentType: "application/json",
        dataType: "json",
        success: function (data, textStatus, jqXhr) {
          var loginForm = document.createElement('form');
          loginForm.name = 'loginForm';
          loginForm.action = '/cleancalculator/j_spring_security_check';
          loginForm.method = 'post';
          loginForm.target = '_self';

          var usernameField = document.createElement('input');
          usernameField.type = 'hidden';
          usernameField.name = 'j_username';
          usernameField.value = values.username;

          var passwordField = document.createElement('input');
          passwordField.type = 'hidden';
          passwordField.name = 'j_password';
          passwordField.value = values.password;
          
          loginForm.appendChild(usernameField);
          loginForm.appendChild(passwordField);
          
          document.body.appendChild(loginForm);

          loginForm.submit();
        },
        error: function (jqXhr, textStatus, errorThrown) {
          if (jqXhr.responseText) {
            let text = JSON.parse(jqXhr.responseText);
            console.log(text);
            if (text.message) {
              // Error handling:
              resetPasswordWindow.form.clearLoading();
              PD.windows.notify.danger(
                PD.homepage.__h("Error"),
                text.message
              );
              return;
            }
          } else {
            // Error handling:
            resetPasswordWindow.form.clearLoading();
            PD.windows.notify.danger(
              PD.homepage.__h("Error"),
              PD.utils.curlyFormat(
                PD.homepage.__h('The system could not handle the request. Please contact support at: {phone}.'),
                { phone: PD.homepage.Support.getPhone() }
              )
            );
          }
        }
      });
    });

    // Clear the feedback from the form:
    resetPasswordWindow.form.clearFeedback();
  }

  login._openResetPasswordForm = function () {
    var resetPasswordWindow = new PD.forms.FormWindow(
      PD.homepage.__h("New password"),
      [
        {
          type: "text",
          name: "reset_password_username",
          label: PD.homepage.__h("Username"),
          placeholder: PD.homepage.__h("Username"),
          errorText: PD.homepage.__h("Enter a valid username"),
          mandatory: true,
          helpText: {
            title: PD.homepage.__h("Username"),
            content: PD.homepage.__h("Your username is generated based on your email.")
          },
        }, {
          type: "password",
          name: "reset_password_password",
          label: PD.homepage.__h("Password"),
          placeholder: PD.homepage.__h("Password"),
          errorText: PD.homepage.__h("Enter a valid password."),
          mandatory: true,
          helpText: {
            title: PD.homepage.__h("Password"),
            content: PD.homepage.__h("Enter a password for your user. The password must be at minimum 6 characters long.")
          }
        }, {
          type: "password",
          name: "reset_password_password_repeat",
          label: PD.homepage.__h("Confirm code"),
          placeholder: PD.homepage.__h("Confirm code"),
          errorText: PD.homepage.__h("Enter a valid password."),
          mandatory: true,
        }, {
          type: "hidden",
          name: "reset_password_hash",
        }, {
          type: "hidden",
          name: "reset_password_type",
        }
      ],
      {
        text: PD.homepage.__h('Enter your username and new password'),
        cancelButton: true,
        actionText: PD.homepage.__h("Change password")
      }
    );

    // Clear the feedback from the form:
    resetPasswordWindow.form.clearFeedback();
  }

  return login;
})(PD.loginpage || {});
